/**
 * @file Mortgage Graph
 */

import { gsap } from 'gsap';

/**
 * Mortgage Graph component
 */
const vMortgageGraph = () => {
	const mortgageGraph = document.querySelector( '.v-mortgage-graph--js' );

	if ( ! mortgageGraph ) {
		return;
	}

	const backHouse       = mortgageGraph.querySelector( '.v-mortgage-graph__back-house' );
	const largeHouseGroup = mortgageGraph.querySelector( '.v-mortgage-graph__large-house' );
	const largeHouse      = largeHouseGroup.querySelector( '.v-mortgage-graph__large-house-building' );
	const chimney         = largeHouseGroup.querySelector( '.v-mortgage-graph__large-house-chimney' );
	const frontHouse      = mortgageGraph.querySelector( '.v-mortgage-graph__front-house' );
	const frontHouseFace  = mortgageGraph.querySelector( '.v-mortgage-graph__front-house-face' );
	const garage          = mortgageGraph.querySelector( '.v-mortgage-graph__garage' );
	const smallHouse      = mortgageGraph.querySelector( '.v-mortgage-graph__small-house-shape' );
	const allElements     = [ backHouse, largeHouse, chimney, frontHouse, frontHouseFace, garage, smallHouse ];
	const animation       = gsap.timeline( {
		defaults: {
			ease:     'sine.inOut',
			duration: .35,
		},
		paused:     true,
		onComplete: () => {
			[ ...allElements ].forEach( ( element ) => {
				element.classList.add( 'complete' );
				element.removeAttribute( 'style' );
			} );
		},
	} )
		.to( smallHouse, {
			transformOrigin: 'bottom center',
			scale:           1.4111589787,
		} )
		.addLabel( 'grow-back-house' )
		.fromTo( largeHouseGroup, {
			transformOrigin: 'bottom center',
			scaleX:          .9,
		}, {
			scaleX:  1,
			onStart: () => {
				largeHouse.style.opacity = 1;
			},
		} )
		.to( smallHouse, {
			scale:      .5,
			onComplete: () => {
				smallHouse.style.opacity = 0;
			},
		} )
		.addLabel( 'grow-front-house' )
		.to( frontHouse, {
			y:       0,
			onStart: () => {
				frontHouse.style.opacity = 1;
			},
		} )
		.to( frontHouseFace, {
			opacity: 1,
		} )
		.addLabel( 'grow-small-buildings' )
		.to( [ backHouse, garage ], {
			opacity: 1,
		} )
		.to( [ backHouse, garage ], {
			x: 0,
		}, '<50%' )
		.to( chimney, {
			y:       0,
			opacity: 1,
		}, 'grow-small-buildings' );

	document.addEventListener( 'vmortgageanimationplay', () => {
		if ( ! animation.paused() || animation.progress() === 1 ) {
			return;
		}

		animation.play();
	} );
};

export default vMortgageGraph;
